<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochd"><a id="page_v"></a>Contents</h1>
<p class="line"> </p>
<h2 class="tocf"><a href="#/xhtml/04_Preface">Preface</a></h2>
<h2 class="tocf"><a href="#/xhtml/05_Foreword">Foreword by Anthony Tucker-Jones</a></h2>
<h2 class="tocf"><a href="#/xhtml/06_Introduction">Introduction</a></h2>
<h2 class="tocfb"><a href="#/xhtml/07_Translator">Translator’s Note</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Chapter1"><span class="tflt">1</span> The Formation of StuG Abteilung 191 at Jüterbog, October–December 1940</a></h2>
<h2 class="toc"><a href="#/xhtml/09_Chapter2"><span class="tflt">2</span> Operations in the Balkans, Spring 1941</a></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter3" title="Link target outside of Sample"><span class="tflt">3</span> The Russian Campaign</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter4" title="Link target outside of Sample"><span class="tflt">4</span> From Kursk to the Caucasus, 1942–1943</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter5" title="Link target outside of Sample"><span class="tflt">5</span> The Retreat from the Caucasus, January–April 1943</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter6" title="Link target outside of Sample"><span class="tflt">6</span> War in the Crimea, 1943–1944</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter7" title="Link target outside of Sample"><span class="tflt">7</span> The Evacuation of the Kuban Bridgehead, 16 September–9 October 1943</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter8" title="Link target outside of Sample"><span class="tflt">8</span> The Struggle for the Crimea, 1943–1944</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter9" title="Link target outside of Sample"><span class="tflt">9</span> Sevastopol, 16 April–13 May 1944</span></h2>
<h2 class="toc1"><span href="#/xhtml/18_Chapter10" title="Link target outside of Sample"><span class="tflt1">10</span> Defending the South-Eastern Front, 1944–1945</span></h2>
<h2 class="tocfa"><span href="#/xhtml/19_Technical" title="Link target outside of Sample">Technical Specifications</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?5980b432